export const findRelatedMediaByTitle = (
    relatedMedia: RelatedMedia[] | undefined,
    title: string,
) => {
    return relatedMedia?.find(
        (item) => item.title?.toLowerCase() === title.toLowerCase(),
    )?.image?.url;
};

export const findRelatedMediaLabelByTitle = (
    relatedMedia: RelatedMedia[] | undefined,
    title: string,
) => {
    return relatedMedia?.find(
        (item) => item.title?.toLowerCase() === title.toLowerCase(),
    )?.label;
};
